// features/licenses/licenseSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchOrganizations = createAsyncThunk(
  'Organizations/fetchOrganizations',
  async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/organizations`,
      {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
        },
      }
    );
    res.data = res.data
      .filter((org) => !org.deleted)
      .sort((a, b) => a.name.localeCompare(b.name));
    console.log('Organizations fetched:', res.data);
    // return res.data.filter((org) => !org.deleted);
    return res.data.filter((org) => !org.deleted);
  }
);


const OrganizationSlice = createSlice({
  name: 'Organizations',
  initialState: {
      organizations: {
        data: [],
        loading: false,
        error: null,
      },
    },
  reducers: {},
   extraReducers: (builder) => {
    // FETCH LICENSES
    builder
      .addCase(fetchOrganizations.pending, (state) => {
        state.organizations.loading = true;
      })
      .addCase(fetchOrganizations.fulfilled, (state, action) => {
        state.organizations.loading = false;
        state.organizations.data = action.payload;
      })
      .addCase(fetchOrganizations.rejected, (state, action) => {
        state.organizations.loading = false;
        state.organizations.error = action.error.message;
      });
  },
});

export default OrganizationSlice.reducer;
